var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ../~/gatsby/~/lodash/_Symbol.js
// module id = 250
// module chunks = 0